<div id="cookie-banner" *transloco="let t">
  <span class="banner-text">🍪 {{ t('cookieBannerText') }}</span>
  <button class="button small" (click)="acceptCookies()">
    {{ t('cookieBannerButtonText') }}
  </button>
</div>
